export enum QuestDisplayType {
    single = 'single',
    tabbed = 'tabbed',
    wizard = 'wizard',
    stepped = 'stepped',
}
